import { createRouter, createWebHistory } from 'vue-router'
import { useVSCStore } from '@/store'

//clientes
import Clientes from '../views/pages/clientes/clientes.vue'
import Clientes2 from '../views/pages/clientes/clientes2.vue'
import Clientes3 from '../views/pages/clientes/clientes3.vue'
import Clientes4 from '../views/pages/clientes/clientes4.vue'

//club de negocios
import ClubNegocios from '../views/pages/negocios/clubnegocios.vue'
import ClubNegocios2 from '../views/pages/negocios/clubnegocios2.vue'
import ClubNegocios3 from '../views/pages/negocios/clubnegocios3.vue'
import ClubNegocios4 from '../views/pages/negocios/clubnegocios4.vue'
import ClubNegocios5 from '../views/pages/negocios/clubnegocios5.vue'

//patrocinador tecnologia
import patrocinadorTecnologia from '@/views/pages/patrocinadores/patrocinadorTecnologia.vue'
import patrocinadorTecnologia2 from '@/views/pages/patrocinadores/patrocinadorTecnologia2.vue'
import patrocinadorTecnologia3 from '@/views/pages/patrocinadores/patrocinadorTecnologia3.vue'
import patrocinadorTecnologia4 from '@/views/pages/patrocinadores/patrocinadorTecnologia4.vue'

//miembros expansion
import miembroExpansion from '@/views/pages/expansion/expansion.vue'
import miembroExpansion2 from '@/views/pages/expansion/expansion2.vue'
import miembroExpansion3 from '@/views/pages/expansion/expansion3.vue'
import miembroExpansion4 from '@/views/pages/expansion/expansion4.vue'

//Loi-Master
import loiMaster from '@/views/pages/loi-master/loi-master.vue'
import loiMaster2 from '@/views/pages/loi-master/loi-master2.vue'
import loiMaster3 from '@/views/pages/loi-master/loi-master3.vue'
import loiMaster4 from '@/views/pages/loi-master/loi-master4.vue'

//campañas
import consultorio from '@/views/pages/campanias/consultorio.vue'
import cupones from '@/views/pages/campanias/cupones.vue'
import cupones2 from '@/views/pages/campanias/cupones2.vue'
import cupones3 from '@/views/pages/campanias/cupones3.vue'
import cupones4 from '@/views/pages/campanias/cupones4.vue'

const routes = [
  {
    path: '/:noPatrocinador(\\d+)?',
    name: 'home',
    component: () => import("../views/Index")
  },
  {
    path: '/registro/campania/:codigo/:patrocinadores(\\d+)*',
    name: 'registroCampania',
    component: () => import("../views/Registro")
  },
    //El siguiente path no es no ideal si hay patrocinadores pero no noPatrocinador, ya no agregar más parámetros
  // opcionales
  {
    path: '/registro/:noPatrocinador(\\d+)?/:patrocinadores(\\d+)*',
    name: 'registro',
    component: () => import("../views/Registro")
  },
  {
    path: '/QR',
    name: 'QR',
    component: () => import("../views/QR")
  },
  {
    path: '/help/:slug',
    name: 'help',
    component: () => import("../views/Help")
  },
  {
    path: '/login',
    name: 'login',
    component: () => import("../views/login"),
    beforeEnter: (to, from) => {
      const store = useVSCStore()
      if (from.name) {
        return !store.isLoggedIn
      } else {
        return !store.isLoggedIn || {name: 'home'}
      }
    }
  },

  // Nuevas rutas para los detalles de los miembros
  //clientes
  {
    path: '/clientes',
    name: 'clientes',
    component: Clientes, // Aquí carga el componente correspondiente
  },
  {
    path: '/clientes2',
    name: 'clientes2',
    component: Clientes2, // Aquí carga el componente correspondiente
  },
  {
    path: '/clientes3',
    name: 'clientes3',
    component: Clientes3, // Aquí carga el componente correspondiente
  },
  {
    path: '/clientes4',
    name: 'clientes4',
    component: Clientes4, // Aquí carga el componente correspondiente
  },
  

  //club de negocios
  {
    path:'/club-negocios',
    name: 'club-negocios',
    component: ClubNegocios,
  },
  {
    path:'/club-negocios2',
    name: 'club-negocios2',
    component: ClubNegocios2,
  },
  {
    path:'/club-negocios3',
    name: 'club-negocios3',
    component: ClubNegocios3,
  },
  {
    path:'/club-negocios4',
    name: 'club-negocios4',
    component: ClubNegocios4,
  },
  

  //patrocinadores de tecnologia
  {
    path:'/patrocinador-tecnologia',
    name: 'patrocinador-tecnologia',
    component: patrocinadorTecnologia,
  },
  {
    path:'/patrocinador-tecnologia2',
    name: 'patrocinador-tecnologia2',
    component: patrocinadorTecnologia2,
  },
  {
    path:'/patrocinador-tecnologia3',
    name: 'patrocinador-tecnologia3',
    component: patrocinadorTecnologia3,
  },
  {
    path:'/patrocinador-tecnologia4',
    name: 'patrocinador-tecnologia4',
    component: patrocinadorTecnologia4,
  },
 

  //miembros expansion 
  {
    path:'/miembro-expansion',
    name: 'miembro-expansion',
    component: miembroExpansion,
  },
  {
    path:'/miembro-expansion2',
    name: 'miembro-expansion2',
    component: miembroExpansion2,
  },
  {
    path:'/miembro-expansion3',
    name: 'miembro-expansion3',
    component: miembroExpansion3,
  },
  {
    path:'/miembro-expansion4',
    name: 'miembro-expansion4',
    component: miembroExpansion4,
  },

  //loi-master
  {
    path:'/loi-master',
    name: 'loi-master',
    component: loiMaster,
  },
  {
    path:'/loi-master2',
    name: 'loi-master2',
    component: loiMaster2,
  },
  {
    path:'/loi-master3',
    name: 'loi-master3',
    component: loiMaster3,
  },
  {
    path:'/loi-master4',
    name: 'loi-master4',
    component: loiMaster4,
  },

  //consultorio
  {
    path:'/vida-nueva-y-saludable',
    name:'consultorio',
    component: consultorio
  },
  //cupones
  {
    path: '/cupones/:noPatrocinador(\\d+)?',
    name: 'cupones',
    component: cupones
  },
  {
    path: '/cupones/:noPatrocinador(\\d+)?/region/:regionId(\\d+)',
    name: 'cupones-con-region',
    component: cupones
  },

  {
    path: '/cupon-digital/:noPatrocinador(\\d+)?',
    name: 'cupon-digital',
    component: cupones2
  },
  {
    path: '/cupon-digital/:noPatrocinador(\\d+)?/region/:regionId(\\d+)',
    name: 'cupon-digital-con-region',
    component: cupones2
  },

  {
    path: '/descuentos/:noPatrocinador(\\d+)?',
    name: 'descuentos',
    component: cupones3
  },
  {
    path: '/descuentos/:noPatrocinador(\\d+)?/region/:regionId(\\d+)',
    name: 'descuentos-con-region',
    component: cupones3
  },

  {
    path: '/promociones/:noPatrocinador(\\d+)?',
    name: 'promociones',
    component: cupones4
  },
  {
    path: '/promociones/:noPatrocinador(\\d+)?/region/:regionId(\\d+)',
    name: 'promociones-con-region',
    component: cupones4
  },

  {
    path:'/club-negocios5/:noPatrocinador(\\d+)?',
    name: 'club-negocios5',
    component: ClubNegocios5,
  },
  {
    path:'/club-negocios5/:noPatrocinador(\\d+)?/region/:regionId(\\d+)',
    name: 'club-negocios5-con-region',
    component: ClubNegocios5,
  },

  //Campañas
  {
    path: '/campania/:codigo',
    name: 'campania',
    component: () => import("../views/campanias/index")
  },

  //Conocenos VSC
  {
    path: '/conocenos',
    name: 'conocenos',
    component: () => import("../views/conocenos.vue")
  },
  
  /*{
    path: '/IA',
    name: 'IA',
    component: IA
  },*/

  //Cartel
  {
    path: '/cartel',
    name: 'cartel',
    component: () => import("../views/cartel/index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cartel-usuario',
    name: 'cartel-usuario',
    component: () => import("../views/cartel/personal"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cartel-campania',
    name: 'cartel-campania',
    component: () => import("../views/cartel/promocion-campanias"),
    meta: {
      requiresAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition){
    if (savedPosition){
      // Si existe una posición guardada (como al navegar hacia atrás), usa esa posición
      return savedPosition
    } else {
      //Desplazate al inicio de la pagina
      return {top: 0}
    }
  },
})

router.beforeEach((to, from) => {
  if (to.meta.requiresAuth) {
    const store = useVSCStore()
    if (!store.isLoggedIn) {
      return {
        name: 'login',
        query: {redirectTo: JSON.stringify({name: to.name, params: to.params, query: to.query})}
      }
    }
  }
})

export default router
